import { useEffect, useRef, useState } from 'react'
import { useInView, useReducedMotion } from 'framer-motion'

// Timing hooks for the interactive service demos (see demoKit.jsx).

/**
 * Plays a scripted sequence once the demo is on screen: returns how many
 * steps have happened (0..delays.length). `delays[i]` is the wait before step
 * i+1. Changing `resetKey` starts over. Reduced motion jumps to the end.
 */
export function useSequence(delays, { run = true, resetKey = 0 } = {}) {
  const reduce = useReducedMotion()
  const [step, setStep] = useState(0)
  const [seenKey, setSeenKey] = useState(resetKey)
  if (seenKey !== resetKey) {
    setSeenKey(resetKey)
    setStep(0)
  }
  useEffect(() => {
    if (!run || reduce || step >= delays.length) return undefined
    const timer = setTimeout(() => setStep((s) => s + 1), delays[step])
    return () => clearTimeout(timer)
  }, [run, reduce, step, delays])
  return reduce ? delays.length : step
}

/** True once at least a third of the element has been on screen. */
export function useOnScreen() {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, amount: 0.35 })
  return [ref, inView]
}
